import { COLORS } from '~/data/ui/colors';
import { styled } from '@mui/system';
import { TextField } from '@mui/material';
import { IUseStyle } from '../ContactUsPopup/components/ScheduleMeeting/useStyles';

export const useStyles: IUseStyle = {
  root: {
    '& .MuiAutocompletePopper': {
      direction: 'rtl',
    },
    border: `1px solid ${COLORS.gray.light2}`,
    borderRadius: '8px',
    padding: '16px',
    backgroundColor: COLORS.white.main,
    minWidth: '325px',
    gap: '16px',
  },
  iconStyle: {
    position: 'absolute',
    left: '10px',
  },
  checkboxesContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '5px',
    paddingTop: '10px',
    '&.paddingTopLarger': {
      paddingTop: '22px',
    },
  },
  dialogTitleWrapper: {
    display: 'grid',
    justifyContent: 'center',
  },
  brandsDropdown: {
    marginTop: '0px',
  },
};

export const formGroupStyle = {};
export const userCarditionalStyle = {
  display: 'flex',
  alignItems: 'flex-end',
  gap: '16px',
};

export const titleStyle = {
  textAlign: 'center',
  fontSize: '24px',
};

export const textStyle = {
  fontSize: '16px',
  fontWeight: 400,
  marginBottom: '16px',
  textAlign: 'center',
  maxWidth: '271px',
};

export const buttonStyle = {
  width: '100%',
  marginTop: '10px',
};

export const helperTextStyle = {
  marginBottom: '16px',
  '& .MuiFormHelperText-root': {
    textAlign: 'right',
    position: 'absolute',
    bottom: '-18px',
    marginRight: '1px',
    right: 0,
  },
};

export const customLocationsInputStyle = {
  height: '46px',
  borderRadius: '8px',
  fontSize: '18px',
  cursor: 'pointer',

  '& p': {
    color: COLORS.gray.dark,
    fontSize: '16px',
    fontWeight: '400',
    flex: '1',
    cursor: 'pointer',
  },
};

export const customOptionsStyle = {
  boxShadow: '0px 4px 24px rgba(0, 0, 0, 0.10)',
};

export const customInnerStyle = {
  maxHeight: '250px',
};

export const hiddenErrorMessage = {
  display: 'none',
};

export const textFieldSx = {
  right: 0,
  left: 'unset',
  textAlign: 'right',
  direction: 'rtl',
  color: COLORS.gray.dark,
  '&.Mui-focused': {
    color: COLORS.gray.dark,
  },
  '&.Mui-error': {
    color: (theme: { palette: { error: { main: any } } }) =>
      theme.palette.error.main, // Error state color
  },
};

export const TextFieldStyled = styled(TextField)({
  marginBottom: '2px',
  '& .placeholder': {
    color: COLORS.gray.dark,
    opacity: 1,
    fontSize: '16px',
  },
  '& .-webkit-input-placeholder': {
    color: COLORS.gray.dark,
    opacity: 1,
    fontSize: '16px',
  },
  '& .MuiInputBase-input': {
    height: '0.6em',
    backgroundColor: COLORS.white.main,
    border: `1px solid ${COLORS.gray.main}`,
    borderRadius: '8px',
  },
  '& .MuiFormLabel-root': {
    color: COLORS.gray.dark,
  },
  '& .MuiFilledInput-root': {
    border: '2px solid transparent',
    borderRadius: '8px',
    transition: 'border-color 0.3s ease-in-out',
    backgroundColor: 'transparent',
    '&::before': {
      display: 'none',
    },
    '&::after': {
      display: 'none',
    },
  },
  '& .MuiFilledInput-root.Mui-focused': {
    borderColor: (theme: { palette: { primary: { main: any } } }) =>
      theme.palette.primary.main,
  },
  '& .MuiFilledInput-root.Mui-error': {
    borderColor: (theme: { palette: { error: { main: any } } }) =>
      theme.palette.error.main, // Error state border color
  },
  // '& .MuiOutlinedInput-input': {
  //   height: '1em',
  // },
  // '& .MuiInputBase-input-MuiOutlinedInput-input': {pcp
  //   height: '1em',
  // },
});
